import { dateMatchesSearch } from 'src/meetings/utils/date-utils';

export type GeneratedDocumentType =
  | 'suitability-report'
  | 'meeting-agenda'
  | 'data-export'
  | 'meeting-note';

export const GENERATED_DOCUMENT_TYPE_LABELS: Record<GeneratedDocumentType, string> = {
  'suitability-report': 'Suitability report',
  'meeting-agenda': 'Meeting agenda',
  'data-export': 'Data export',
  'meeting-note': 'Meeting note',
};

export const GENERATED_DOCUMENT_TYPE_LABELS_PLURAL: Record<GeneratedDocumentType, string> = {
  'suitability-report': 'Suitability reports',
  'meeting-agenda': 'Meeting agendas',
  'data-export': 'Data exports',
  'meeting-note': 'Meeting notes',
};

type SearchableGeneratedDocument = {
  displayName: string;
  documentType: GeneratedDocumentType;
  createdAt: string;
};

export function matchesGeneratedDocumentSearch(
  doc: SearchableGeneratedDocument,
  searchValue: string,
): boolean {
  const searchLower = searchValue.toLowerCase();
  return (
    doc.displayName.toLowerCase().includes(searchLower) ||
    GENERATED_DOCUMENT_TYPE_LABELS[doc.documentType].toLowerCase().includes(searchLower) ||
    dateMatchesSearch(doc.createdAt, searchLower)
  );
}
